export default __webpack_public_path__ + "static/media/linkedin.58bc0cef.svg";